import { render, staticRenderFns } from "./ResumeRemarks.vue?vue&type=template&id=50130945&scoped=true&"
import script from "./ResumeRemarks.vue?vue&type=script&lang=js&"
export * from "./ResumeRemarks.vue?vue&type=script&lang=js&"
import style0 from "./ResumeRemarks.vue?vue&type=style&index=0&id=50130945&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50130945",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
